import './share-button.less';
import MagnificPopup from '../../scripts/common/dynamic-imports/MagnificPopup.js';
import componentRegistry from '../registry.js';
import iconEnvelope from '@fnacdarty/fnac-icons/svg/envelope.svg?svgref';
import iconFacebook from '@fnacdarty/fnac-icons/svg/facebook.svg?svgref';
import iconHTML from '../../helpers/html/icon.js';
import iconTwitter from '@fnacdarty/fnac-icons/svg/twitter.svg?svgref';

/** Test page: any mobile product page, share button near product visuals */
export default class ShareOpen {
  constructor({ el }) {
    this.el = el;
    this.magnificPopup = new MagnificPopup();
    el.addEventListener('click', this._handleClick.bind(this));
  }

  _handleClick() {
    // Use native feature if supported instead
    if (navigator.canShare && IS_MOBILE) {
      navigator.share({
        url: Object.assign(new URL(document.location), { hash: '' }).href,
        text: document.querySelector('meta[property="og:title"]')?.getAttribute('content'),
        title: document.title,
      });
      return;
    }

    const renderSharePopin = `
      <div id="sharePopinContent"
        class="f-tools__popin js-sharePopin ff-modal ${!IS_MOBILE ? 'ff-modal--small' : ''}" role="dialog">
        <button type="button" class="ff-button--block ff-button ff-button--facebook js-share" data-type="facebook">
          ${iconHTML(iconFacebook, { className: 'icon_tag' })}
        </button>
        <button type="button" class="ff-button--block ff-button ff-button--dark js-share" data-type="twitter">
          ${iconHTML(iconTwitter, { className: 'icon_tag' })}
        </button>
        <button type="button" class="ff-button--block ff-button ff-button--orange js-share" data-type="email"
          data-title="${this.el.dataset.emailSubject}" data-text="${this.el.dataset.emailBody}">
          ${iconHTML(iconEnvelope, { className: 'icon_tag' })}
        </button>
      </div>
    `;

    this.magnificPopup.open({
      mainClass: `mfp--modal${IS_MOBILE ? ' mfp--mobile' : ''}`,
      items: {
        src: renderSharePopin,
      },
    });
  }
}

componentRegistry.define('js-share-open', ShareOpen);
